import gql from 'graphql-tag';

export const SUBMIT_QUESTION = gql`
  mutation ServiceTicket($encryptedIncident: String!) {
    createIncident(encryptedIncident: $encryptedIncident) {
      incidentId
    }
  }
`;
